import { render, staticRenderFns } from "./UploadImgMedia.vue?vue&type=template&id=046d0534&scoped=true&"
import script from "./UploadImgMedia.vue?vue&type=script&lang=js&"
export * from "./UploadImgMedia.vue?vue&type=script&lang=js&"
import style0 from "./UploadImgMedia.vue?vue&type=style&index=0&id=046d0534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d0534",
  null
  
)

export default component.exports